import React from 'react'
import PropTypes from 'prop-types'

import { Flex, Row } from 'Components/UI/_Legacy'

import DataBlock from './DataBlock'
import ImageBlock from './ImageBlock'
import {
  PathCornerBL,
  PathCornerBR,
  PathCornerTL,
  PathCornerTR,
  PathHorizontal,
  PathVerticalLong,
} from './paths'
import { Block, Container, Content } from './styles'

const horizontalLine = mirror => (
  <Flex width="calc(50% + 1px)">
    {!mirror ? <PathCornerTL /> : <PathCornerBL />}
    <Flex overflow="hidden">
      <Row>
        <PathHorizontal />
      </Row>
    </Flex>
    {!mirror ? <PathCornerBR /> : <PathCornerTR />}
  </Flex>
)

const horizontalDelimiter = (index, odd) =>
  index < 5 && (
    <Flex backgroundColor="white" display={['none', 'none', 'flex']} zIndex={6}>
      {odd ? horizontalLine(false) : horizontalLine(true)}
    </Flex>
  )

function RoadMap({ data, rendered }) {
  return (
    <Container>
      <PathVerticalLong />

      {data.map((step, index) => {
        const odd = !(index % 2)
        return (
          <Content key={step.id}>
            <Block
              flexDirection={['column', 'column', odd ? 'row' : 'row-reverse']}
              zIndex={index + 1}
            >
              <Flex pr={odd ? 5 : 0} width={[1, 1, 1 / 2]}>
                <DataBlock index={index} odd={odd} step={step} />
              </Flex>

              <Flex
                justifyContent={['center', 'center', 'flex-start']}
                width={[1, 1, 1 / 2]}
              >
                <ImageBlock index={index} rendered={rendered} />
              </Flex>
            </Block>
            {horizontalDelimiter(index, odd)}
          </Content>
        )
      })}
    </Container>
  )
}

RoadMap.defaultProps = {
  data: [],
}

RoadMap.propTypes = {
  data: PropTypes.array,
  rendered: PropTypes.bool.isRequired,
}

export default RoadMap
